module.exports = "<p>Google Calendar API Quickstart</p>\r\n\r\n    <!--Add buttons to initiate auth sequence and sign out-->\r\n    <button id=\"authorize_button\" (click)=\"handleAuthClick()\" >Authorize</button>\r\n    <button id=\"signout_button\" (click)=\"handleSignoutClick()\">Sign Out</button>\r\n    <pre id=\"content\" style=\"white-space: pre-wrap;\"></pre>\r\n"


//////////////////
// WEBPACK FOOTER
// C:/prj/liveplanet-app-site/src/app/components/+integrationCode/calendarcomponent.html
// module id = ../../../../../src/app/components/+integrationCode/calendarcomponent.html
// module chunks = main